import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://bggukerwbmvjnecabazx.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJnZ3VrZXJ3Ym12am5lY2FiYXp4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk0ODAyNjMsImV4cCI6MjA1NTA1NjI2M30.v84_pUe4MyIVvsbc_h5Ps3qMTBaDhRURD1ZDsdywas4";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
